import { Badge } from "../ui/badge";

const getRankingColor = (ranking: number) => {
      if (ranking === null || ranking === undefined || ranking === 0) return "bg-muted text-muted-foreground";
      if (ranking <= 3) return "bg-success-light text-success";
      if (ranking <= 6) return "bg-warning-light text-warning";
      if (ranking <= 9) return "bg-destructive/10 text-destructive/80";
      return "bg-destructive/10 text-destructive";
};

export const RankingPill = ({ ranking }: { ranking: number }) => {
      const color = getRankingColor(ranking);
      return <Badge className={`text-center rounded-full ${color}`}>{ranking}</Badge>;
};
